import { ApiResource } from '../api-resource';
import { Registration } from '../registration/registration.model';
import { CourseTheme } from '../course-theme/course-theme.model';
import { Absence, getDefaultAbsenceObject } from '../_lib/absence';
import { Camp } from '../camp/camp.model';
import {
  DateField,
  Field,
  NumberField,
  StringField,
} from '../../util/components/resource/resource-fields/resource-fields';
import { Endpoint } from '../api.decorators';
import { ActivityRole } from '../activity/lib/activity.interfaces';
import { OpenSpotsInformation } from '../application/lib/application.interfaces';
import { Activity } from '../activity/activity.model';
import { formatTableDate } from '../../util/date';
import { getScheduleInterval } from '../_lib/schedule';

@Endpoint('courses', 'Course')
export class Course extends ApiResource<Course> {
  @NumberField({ label: $localize`Price` })
  price!: number;

  @NumberField({
    default: () => 0,
    label: $localize`Minimum age`,
  })
  minAge!: number;

  @NumberField({
    default: () => 18,
    label: $localize`Maximum age`,
  })
  maxAge!: number;

  @NumberField({
    default: () => 0,
    label: $localize`Minimum attendants`,
  })
  minAttendants!: number;

  @NumberField({
    default: () => 50,
    label: $localize`Maximum attendants`,
  })
  maxAttendants!: number;

  @Field({ default: getDefaultAbsenceObject, includeFilter: false })
  absence!: Absence;

  @Field({ label: $localize`Camp` })
  camp!: Camp;

  @Field({ label: $localize`Theme` })
  theme!: CourseTheme;

  @DateField({
    default: () => null,
    label: $localize`Registrations opened at`,
  })
  registrationsOpenedAt!: Date | null;

  @DateField({
    default: () => null,
    label: $localize`Applications opened at`,
  })
  applicationsOpenedAt!: Date | null;

  @Field({
    default: () => [ActivityRole.Monitor],
    type: () => ActivityRole,
    label: $localize`Required staff`,
  })
  requiredStaff!: ActivityRole[];

  @Field({ type: () => Registration, readonly: true, includeFilter: false })
  attendants!: Registration[];

  @Field({ type: () => Activity, includeFilter: false })
  activities!: Activity[];

  @StringField({ label: $localize`Items to bring` })
  itemsToBring!: string;

  @Field({ includeFilter: false })
  openSpotsInformation?: OpenSpotsInformation;

  full!: boolean;
  remainingCapacity!: number;

  get name() {
    return this.theme.name;
  }

  get address() {
    return this.camp.location.address;
  }

  get locationName() {
    return this.camp.location.name;
  }

  override toLabel(): string {
    return `${this.name} ${this.locationName} ${formatTableDate(getScheduleInterval(this.camp.schedule).start)}`;
  }
}
